import { getBusinessUnitPath } from "./businessUnits"

export function getCRMMeetingTypesPath(businessUnitId: string) {
  return `${getBusinessUnitPath(businessUnitId)}/crm/meeting_types`
}
